import { render } from "./CapturaRapida.vue?vue&type=template&id=21e35c72&scoped=true"
import script from "./CapturaRapida.vue?vue&type=script&lang=js"
export * from "./CapturaRapida.vue?vue&type=script&lang=js"

import "./CapturaRapida.vue?vue&type=style&index=0&id=21e35c72&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e35c72"]])

export default __exports__